module.exports = __webpack_public_path__ + "img/Group-Discussion.2f5d55b0.png";